import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {of} from 'rxjs';

import * as UpdateOrganizationActions from '../actions/update-organization.actions';
import {MatSnackBar} from '@angular/material/snack-bar';
import {OrganizationsService} from '../../../services/api/organizations/organizations.service';
import {Router} from '@angular/router';
import {Organization, UpdateOrganizationParameters} from '../../../services/api/organizations/models/organization.model';


@Injectable()
export class UpdateOrganizationEffects {

  // noinspection JSUnusedGlobalSymbols
  updateOrganization$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UpdateOrganizationActions.updateOrganization),
      concatMap((payload: UpdateOrganizationParameters) =>
        this.organizationsService.updateOrganization(payload.id, payload.data)
          .pipe(
            map((data: Organization) => UpdateOrganizationActions.updateOrganizationSuccess({data})),
            catchError(error => of(UpdateOrganizationActions.updateOrganizationFailure({error})))
          )
      )
    );
  });

  // noinspection JSUnusedGlobalSymbols
  updateOrganizationSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UpdateOrganizationActions.updateOrganizationSuccess),
      tap(() => {
        this.snackBar.open('Organization successfully updated', 'Success', {duration: 3000});
        if (this.router.url.includes('/organizations/')) {
          this.router.navigate(['/organizations']);
        } else {
          this.router.navigate(['/organization']);
        }
      })
    );
  }, {dispatch: false});


  constructor(
    private readonly actions$: Actions,
    private readonly organizationsService: OrganizationsService,
    private readonly router: Router,
    private readonly snackBar: MatSnackBar
  ) {
  }

}
